import type { ReactNode } from 'react';

import { SharedTrackingProvider } from '@web-platform/shared-universal-tracking/src/SharedTrackingContext/SharedTrackingContext';

import { trackBehaviouralEvent } from '../trackBehaviouralEvent';

export const AcornSharedTrackingProvider = ({ children }: { children: ReactNode }) => (
  <SharedTrackingProvider
    value={{
      trackGenericEvent: trackBehaviouralEvent,
    }}
  >
    {children}
  </SharedTrackingProvider>
);
